import type { DataCenterSource } from "@/workflow/components/configurations/data-center/types";
import type {
  GetTablesParams,
  PaginatedResponse,
  Table,
} from "./data-center.types";

export const getSourceEndpoint = (source: DataCenterSource) => {
  switch (source) {
    case "Orquestador":
      return "/admin/v1/data-center/sources/ORQUESTADOR/tables";
    case "Operador":
      return "/admin/v1/data-center/sources/OPERADOR/tables";
    case "sdt":
    default:
      return "/admin/v1/data-center/tables";
  }
};

export const appendSourceToTables = (
  data: PaginatedResponse<Table>,
  source: DataCenterSource,
): PaginatedResponse<Table> => {
  return {
    ...data,
    data: data.data.map((table) => ({
      ...table,
      id: source === "sdt" ? table.id : table.name,
      useName: false,
      source,
    })),
  };
};

function resolveTrashedFilter(statusValue?: string): string | undefined {
  if (statusValue === "ACTIVE") return "";
  if (statusValue === "ACTIVE,INACTIVE") return "with";
  if (statusValue === "INACTIVE") return "only";
  return undefined;
}

export function buildTableQueryParams(params?: GetTablesParams) {
  const {
    page,
    per_page,
    filters,
    order_by,
    search,
    role_id,
    orderDirection,
    columns,
  } = params || {};
  const statusValue = filters?.find((obj) => obj.status)?.status;
  const updated_at = filters?.find(
    (obj) => obj.updated_at !== undefined,
  )?.updated_at;
  const created_at = filters?.find(
    (obj) => obj.created_at !== undefined,
  )?.created_at;
  const trashedFilter = resolveTrashedFilter(statusValue);

  return {
    ...(page && { page }),
    ...(per_page && { per_page }),
    ...(trashedFilter && { "filter[trashed]": trashedFilter }),
    ...(order_by && {
      order_by: orderDirection === "desc" ? `!${order_by}` : order_by,
    }),
    ...(updated_at && { ["filter[updated_at]"]: updated_at }),
    ...(created_at && { ["filter[created_at]"]: created_at }),
    ...(role_id && { role: role_id }),
    ...(columns !== undefined && { "filter[columns]": columns }),
    filter: { ...(search && { search }) },
  };
}

export const EMPTY_PAGINATED_RESPONSE = (perPage: number) => ({
  data: [] as Table[],
  links: { first: "", last: "", prev: null, next: null },
  meta: {
    current_page: 1,
    from: 0,
    last_page: 1,
    links: [],
    path: "",
    per_page: perPage,
    to: 0,
    total: 0,
  },
});
